import axios from "axios";

const url = axios.create({
  baseURL: "https://dev-api.er-1.co.id/api/v1",
});

export { url }